import React, { useState } from 'react';
import { MATURITY_LEVELS } from '../../constants/assessmentTypes';
import { ChevronDown, ChevronRight, X } from 'lucide-react';

const StrategyInfoModal = ({ strategyInfo, onClose }) => {
  const [activeTab, setActiveTab] = useState('ML1');
  
  if (!strategyInfo) return null;

  // Helper function to format the content with proper styling
  const formatContent = (text) => {
    // Split into paragraphs
    return text.split('\n\n').map((paragraph, i) => {
      // Check if paragraph contains emoji or special formatting
      if (paragraph.includes('✅') || paragraph.includes('⚠️')) {
        // Bold the heading
        const parts = paragraph.split('\n');
        const heading = parts[0];
        const rest = parts.slice(1).join('\n');
        
        return (
          <div key={i} className="mb-6">
            <h4 className="font-bold text-base mb-2">{heading}</h4>
            <p className="whitespace-pre-line">{rest}</p>
          </div>
        );
      }
      
      return (
        <p key={i} className="mb-4 text-gray-700 whitespace-pre-line">
          {paragraph}
        </p>
      );
    });
  };
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="p-4 border-b border-gray-200 flex justify-between items-center">
          <h2 className="text-xl font-bold">{strategyInfo.title}</h2>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <X className="w-6 h-6" />
          </button>
        </div>
        
        {/* Tabs */}
        <div className="flex border-b border-gray-200">
          {Object.keys(strategyInfo.maturityLevels).map((mlKey) => (
            <button
              key={mlKey}
              className={`py-3 px-6 font-medium text-sm ${
                activeTab === mlKey 
                  ? 'border-b-2 border-blue-500 text-blue-600' 
                  : 'text-gray-500 hover:text-gray-700'
              }`}
              onClick={() => setActiveTab(mlKey)}
            >
              Maturity Level {mlKey.substring(2)}
            </button>
          ))}
        </div>
        
        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6">
          <div className="prose max-w-none">
            <h3 className="text-lg font-semibold mb-4">{strategyInfo.maturityLevels[activeTab].title}</h3>
            <div className="space-y-2">
              {formatContent(strategyInfo.maturityLevels[activeTab].description)}
            </div>
          </div>
        </div>
        
        {/* Footer */}
        <div className="bg-gray-100 px-6 py-3 flex justify-end">
          <button 
            onClick={onClose}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default StrategyInfoModal; 